import { Component, OnInit, Input } from '@angular/core';
import { ProjectInfoComponent } from '../project.info.component';

@Component({
  selector: 'app-project-info-mobile',
  templateUrl: './project-info-mobile.component.html',
  styleUrls: ['./project-info-mobile.component.scss']
})
export class ProjectInfoMobileComponent extends ProjectInfoComponent implements OnInit {


  ngOnInit(): void {
    super.ngOnInit();
  }

}
